
import React from 'react';

import styled from 'styled-components';

const Svg = styled.svg`
	.cls-1{fill:none;stroke:#2d2d2d;stroke-linejoin:round;stroke-width:2px;}
`;

const Dress = () => {
	return (
		<Svg
			xmlns='http://www.w3.org/2000/svg'
			data-name='Layer 3'
			viewBox='0 0 22 32'
		>
			<path
				d='M22 13h-8s-6 1.5-6 12a22.88 22.88 0 0010 2 22.88 22.88 0 0010-2c0-10.5-6-12-6-12zM18 8.5a2.5 2.5 0 00-5 0l1 4.5h8l1-4.5a2.5 2.5 0 00-5 0z'
				className='cls-1'
				transform='translate(-7 -2)'
			></path>
			<circle cx='6.5' cy='18.5' r='0.5' className='cls-1'></circle>
			<circle cx='12.5' cy='14.5' r='0.5' className='cls-1'></circle>
			<circle cx='15.5' cy='20.5' r='0.5' className='cls-1'></circle>
			<path d='M2 31L20 31' className='cls-1'></path>
			<path
				d='M13 8h-3V7a4 4 0 014-4h1v3.05M23 8h3V7a4 4 0 00-4-4h-1v3.05'
				className='cls-1'
				transform='translate(-7 -2)'
			></path>
		</Svg>
	);
};

export default Dress;
